import { SET_SHOW_NO_SIZE_SELECTED_WARNING } from "../actions/pdp-actions";

const defaultState = {};

export default function cartReducer(state = defaultState, { type, payload }) {
  switch (type) {
    case SET_SHOW_NO_SIZE_SELECTED_WARNING:
      return { ...state, showNoSizeSelectedWarning: payload };
    default:
      return state;
  }
}
